import { render } from "./Street.vue?vue&type=template&id=6bdc7eac&scoped=true&bindings={\"blurredAtStart\":\"props\",\"audio\":\"data\",\"blurred\":\"data\",\"showModal\":\"data\",\"muted\":\"data\",\"playSound\":\"options\",\"pauseSound\":\"options\",\"nextStep\":\"options\",\"onClick\":\"options\",\"goToOnePagePDF\":\"options\",\"closeModal\":\"options\",\"openInNewTab\":\"options\",\"switchSound\":\"options\"}"
import script from "./Street.vue?vue&type=script&lang=js"
export * from "./Street.vue?vue&type=script&lang=js"

import "./Street.vue?vue&type=style&index=0&id=6bdc7eac&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6bdc7eac"

export default script